import { defineComponent, computed } from "vue";
import { definePropType } from "@types-vue/props";
import ManageForbiddenFont from "./manage-forbidden-font.vue";
export default defineComponent({
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        /* '取消/确认'按钮loading */ loading: {
            type: Boolean,
            default: false
        },
        // 字体库数据
        fontOptions: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        },
        /** 缺失字体数据
     * forbiddenFontList: {
     *   [lang]: [
     *             {forbiddenFont:{},newFont:{}},
     *             {forbiddenFont:{},newFont:{}}, ...
     *   ]
     * }
     * lang: 语言，eg:en、ru等
     * forbiddenFont: 缺失字体; 数据格式为字体库接口返回数据格式（/pt/common/asset/no-shelf-fonts）；
     * newFont: 替换字体（如果为空对象则自动展示默认值）; 数据格式为资产库字体接口返回的数据（/pt/common/asset-tag/assets）;
     */ forbiddenFontList: {
            type: definePropType(Object),
            default: function() {}
        },
        /* 提示文案 */ message: {
            type: String
        },
        // 1.ps工具 2.视频工具
        tool: {
            type: Number,
            default: 1
        },
        // 不展示关闭和取消按钮
        disableCancel: {
            type: Boolean,
            default: false
        },
        // 自定义字体
        assetFontConfig: {
            type: definePropType(Object),
            default: function() {}
        }
    },
    components: {
        ManageForbiddenFont: ManageForbiddenFont
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var dialogVisible = computed({
            get: function() {
                return props.visible;
            },
            set: function(val) {
                emit("update:visible", val);
            }
        });
        var handleClose = function() {
            if (!props.loading) {
                emit("update:visible", false);
            }
        };
        var handleSubmit = function() {
            /** 提交修改
       * 数据里面newFont:{}时，可根据具体场景设置默认字体；
       */ emit("submit", props.forbiddenFontList);
        };
        return {
            dialogVisible: dialogVisible,
            handleClose: handleClose,
            handleSubmit: handleSubmit
        };
    }
});
